// -----------------------------------------------------------------------------
// Penz Ürün Turu — ortak başlatıcı.
//
// Aynı tur hem (kaldırılan) Dashboard test butonundan hem de Ayarlar sayfasındaki
// "Penz'i Keşfet" kartından çağrılabilsin diye buraya taşındı.  Davranış, adımlar,
// metinler ve görsel özelleştirmeler önceki Dashboard sürümüyle birebir aynıdır.
// -----------------------------------------------------------------------------
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "@/styles/driver-overrides.css";

const TOTAL = 5;
const CLOSING = 5; // 0-based index of closing step

const STEPS = [
  {
    element: '[data-testid="tour-dashboard-top"]',
    popover: {
      title: "İşinizin Genel Görünümü",
      description: "Gelir, gider, tahsilat ve kârlılık durumunuzu tek ekrandan takip edin.",
      side: "bottom", align: "center",
    },
  },
  {
    element: '[data-testid="nav-customers"]',
    popover: {
      title: "Müşteri Yönetimi",
      description: "Çalıştığınız kişi ve firmaları kaydedin, tüm iş geçmişlerini tek yerden yönetin.",
      side: "right", align: "center",
    },
  },
  {
    element: '[data-testid="nav-jobs"]',
    popover: {
      title: "Her İşi Ayrı Yönetin",
      description: "Her işinizi ayrı takip edin. Gelir, gider ve kârlılığını tek ekranda görün.",
      side: "right", align: "center",
    },
  },
  {
    element: '[data-testid="nav-cash"]',
    popover: {
      title: "Nakit Akışınızı Takip Edin",
      description: "Kasalar sayesinde işletmenizin güncel nakit durumunu ve tüm kasa hareketlerini kolayca takip edebilirsiniz.",
      side: "right", align: "center",
    },
  },
  {
    element: '[data-testid="nav-reports"]',
    popover: {
      title: "İşinizin Gerçek Sonuçlarını Görün",
      description: "Ciro, tahsilat, gider, nakit akışı ve kârlılık raporlarını tek yerden inceleyin.",
      side: "right", align: "center",
    },
  },
  {
    // Kapanış — element yok → popover ekranın ortasında modal olarak açılır.
    popover: {
      title: "Penz için Hazırsınız!",
      description: "Müşterilerinizi, işlerinizi ve finansal süreçlerinizi artık Penz ile kolayca yönetmeye başlayabilirsiniz.",
    },
  },
];

/**
 * Ürün turunu baştan başlatır.  Dashboard sayfası açık değilse ilk adımın
 * hedefi (`[data-testid="tour-dashboard-top"]`) DOM'da bulunmayabilir — bu
 * durumda çağıran taraf navigate('/') yapmalıdır (Settings kartı öyle yapar).
 */
export function startProductTour() {
  const d = driver({
    showProgress: false,          // özel progress "N / 5" onPopoverRender ile
    allowClose: true,
    showButtons: ["next", "previous", "close"],
    nextBtnText: "İleri",
    prevBtnText: "Geri",
    doneBtnText: "Kullanmaya Başla",
    overlayOpacity: 0.65,
    stagePadding: 6,
    stageRadius: 12,
    steps: STEPS,
    onPopoverRender: (popover, opts) => {
      const idx = opts.state.activeIndex ?? 0;
      const isClosing = idx === CLOSING;

      // Üstte "N / 5" ilerleme etiketi
      if (!isClosing) {
        const prog = document.createElement("div");
        prog.textContent = `${idx + 1} / ${TOTAL}`;
        prog.style.cssText =
          "font-size:11px;color:#64748b;letter-spacing:0.08em;text-transform:uppercase;font-weight:600;margin-bottom:8px;";
        popover.title?.before(prog);
      }

      // Kapanış: Geri butonunu gizle, next → "Kullanmaya Başla", P logo + alt bilgi
      if (isClosing) {
        if (popover.previousButton) popover.previousButton.style.display = "none";
        if (popover.nextButton) popover.nextButton.innerText = "Kullanmaya Başla";

        if (popover.title) {
          const logo = document.createElement("img");
          logo.src = "/penz-icon.png";
          logo.alt = "Penz";
          logo.style.cssText =
            "display:inline-block;vertical-align:-3px;width:20px;height:20px;object-fit:contain;margin-right:8px;";
          popover.title.prepend(logo);
        }

        const foot = document.createElement("div");
        foot.textContent =
          "Ürün turunu istediğiniz zaman Ayarlar > Penz'i Keşfet bölümünden yeniden başlatabilirsiniz.";
        foot.style.cssText =
          "font-size:11px;color:#94a3b8;margin-top:14px;line-height:1.5;text-align:center;";
        popover.footer?.before(foot);
      }
    },
  });
  d.drive();
}
